<script setup lang="ts">
import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useAuthStore } from '@/stores/auth';

const route = useRoute();
const router = useRouter();
const auth = useAuthStore();

const blank = computed(() => route.meta.layout === 'blank');

function logout() {
  auth.logout();
  router.push({ name: 'login' });
}
</script>

<template>
  <v-app>
    <template v-if="!blank">
      <v-app-bar color="surface" elevation="1" :flat="false">
        <v-app-bar-title>
          <span class="brand-display text-h6 brand-red">SLICE OF VEGAS</span>
          <span class="brand-display text-h6 ml-2">— Admin</span>
        </v-app-bar-title>

        <v-tabs :model-value="route.name as string">
          <v-tab :to="{ name: 'dashboard' }" value="dashboard" prepend-icon="mdi-view-dashboard">Dashboard</v-tab>
          <v-tab :to="{ name: 'campaigns' }" value="campaigns" prepend-icon="mdi-bullhorn">Campaigns</v-tab>
          <v-tab :to="{ name: 'games' }" value="games" prepend-icon="mdi-basketball">Games</v-tab>
          <v-tab :to="{ name: 'submissions' }" value="submissions" prepend-icon="mdi-table">Submissions</v-tab>
          <v-tab :to="{ name: 'entries' }" value="entries" prepend-icon="mdi-trophy">Entries</v-tab>
          <v-tab v-if="auth.user?.role === 'root'" :to="{ name: 'users' }" value="users" prepend-icon="mdi-account-multiple">Users</v-tab>
        </v-tabs>

        <v-spacer />

        <v-menu>
          <template #activator="{ props }">
            <v-btn v-bind="props" variant="text" prepend-icon="mdi-account-circle">
              {{ auth.user?.email || 'Account' }}
            </v-btn>
          </template>
          <v-list>
            <v-list-item @click="logout" prepend-icon="mdi-logout">Sign out</v-list-item>
          </v-list>
        </v-menu>
      </v-app-bar>
    </template>

    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>
